export default __webpack_public_path__ + "static/media/icons8-broken-link.f96337a8.svg";